module.exports = __webpack_public_path__ + "static/media/cardAgent.85d4b378.svg";